﻿export * from './not-found.component';